import { Navigate, Outlet } from 'react-router-dom';
import { useTier, type Tier } from '../../hooks/useTier';

/**
 * Gate nested admin routes by adminTier. A non-matching admin is bounced to
 * the admin dashboard (route guards on the backend enforce this regardless).
 */
export function RequireTier({ allow }: { allow: Exclude<Tier, null>[] }) {
  const { tier } = useTier();
  if (!tier || !allow.includes(tier)) {
    return <Navigate to="/admin/dashboard" replace />;
  }
  return <Outlet />;
}
